//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const StubSkipsValueWhenHidden: FeatureFlag = {"Id":"StubSkipsValueWhenHidden","Label":"(KILL)[10.28]StubSkipsValueWhenHidden","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, a control on a page the viewer cannot see, whose value the server already worked out, shows that value as sent. When disabled, the browser applies the control's Value when Hidden setting to it again, which can blank the value and any input that calculates from it.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
